/**
 * Import Validation Configurations
 *
 * This file contains validation configurations for all import pages.
 * Each config defines validation rules for fields in a declarative way.
 */

import { SharedMsgHelper } from '../utils/SharedMsgHelper';

export interface FieldValidation {
    required?: boolean;
    type?: 'number' | 'integer' | 'date' | 'enum';
    enumValues?: string[];
    customValidator?: (value: any) => string | null; // returns error message or null if valid
}

export interface ImportValidationConfig {
    [fieldName: string]: FieldValidation;
}

// ============================================================================
// Direct Order Import Validation
// ============================================================================
export const DirectOrderImportValidation: ImportValidationConfig = {
    directOrderName: { required: true },
    directOrderPhone: { required: true },
    directOrderAddress1: { required: true },
    directOrderAddress2: { required: true },
    directOrderPostalcode: { required: true },
    directOrderCity: { required: true },
    directOrderState: { required: true },
    directOrderCountry: { required: true },
    customerReference: { required: true }
};

// ============================================================================
// Update Direct Order Status Import Validation
// ============================================================================
export const UpdateDirectOrderStatusImportValidation: ImportValidationConfig = {
    directOrderNumber: {
        required: true,
        customValidator: (value) => {
            if (!/^[a-zA-Z0-9]*$/.test(value)) {
                return SharedMsgHelper.getNotAlphanumericErrMsg;
            }
            return null;
        }
    }
};
